import React, { useContext, useEffect, useState } from "react";
import "./leaderboard.css";
import TopLeaderBoard from "./TopLeaderBoard";
import { LeaderBoardShowProps, LeaderProps } from "./leaderBoardTypes";
import QuestContext from "../../../../components/QuestWrapper";
import QuestLabs from "../../../../components/QuestLabs";
import LeaderboardThemeManager from "./LeaderboardThemeManager";

const LeaderBoardShow: React.FC<LeaderBoardShowProps> = ({
  leaderboardUserData,
  memberShip,
  styleConfig,
  FirstRankIconImage,
  SecondRankIconImage,
  ThirdRankIconImage,
  IsTopRank,
  isXpImage,
  rewardHead,
  presentUserRank,
  DefaultImage,
  brandTheme,
  questThemeData,
  onUserClick,
  showFooter,
  customUnit,
  customUnitImage
}) => {
  const [first, setFirst] = useState<LeaderProps | null>(null);
  const [second, setSecond] = useState<LeaderProps | null>(null);
  const [third, setThird] = useState<LeaderProps | null>(null);
  const [rest, setRest] = useState<LeaderProps[]>([]);
  const { themeConfig } = useContext(QuestContext.Context);

  const themeManager = new LeaderboardThemeManager(
    themeConfig,
    styleConfig,
    questThemeData,
    brandTheme
  );

  useEffect(() => {
    if (leaderboardUserData && leaderboardUserData.data && leaderboardUserData.data.length > 0) {
      setFirst(leaderboardUserData.data[0]);
      if (leaderboardUserData.data.length > 1) {
        setSecond(leaderboardUserData.data[1]);
      }
      if (leaderboardUserData.data.length > 2) {
        setThird(leaderboardUserData.data[2]);
        setRest(leaderboardUserData.data.slice(3));
      }
    } else {
      setFirst(null);
      setSecond(null);
      setThird(null);
      setRest([]);
    }
  }, [leaderboardUserData]);

  const renderEmptyState = () => (
    <div
      style={{
        color: "white",
        textAlign: "center",
        height: "140vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      It seems your leaderboard is empty at the moment.
    </div>
  );

  return (
    <div
      className="q_leaderboard_main_cont"
      style={themeManager.getContainerStyles()}
    >
      <div
        className="q_leaderboard_main_heading"
        style={themeManager.getMainHeadingStyles()}
      >
        Leaderboard
      </div>

      <div className="q_position_main_container">
        {first ? (
          <TopLeaderBoard
            first={first}
            second={second}
            third={third}
            rest={rest}
            memberShip={memberShip}
            styleConfig={styleConfig}
            FirstRankIconImage={FirstRankIconImage}
            SecondRankIconImage={SecondRankIconImage}
            ThirdRankIconImage={ThirdRankIconImage}
            IsTopRank={IsTopRank}
            isXpImage={isXpImage}
            rewardHead={rewardHead}
            presentUserRank={presentUserRank}
            DefaultImage={DefaultImage}
            brandTheme={brandTheme}
            questThemeData={questThemeData}
            onUserClick={onUserClick}
            customUnit={customUnit}
            customUnitImage={customUnitImage}
          />
        ) : (
          renderEmptyState()
        )}
      </div>

      {showFooter && <div className="q_footer_leaderboard">
        <QuestLabs
          style={themeManager.getFooterStyles().container}
          textStyle={themeManager.getFooterStyles().text}
          iconStyle={themeManager.getFooterStyles().icon}
          text={themeManager.getFooterStyles().content.text}
          link={themeManager.getFooterStyles().content.link}
        />
      </div>}
    </div>
  );
};

export default LeaderBoardShow;